import React from 'react';
import { motion } from 'framer-motion';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onProductClick }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 lg:gap-8 xl:gap-9 p-5 bg-white shadow-lg rounded-[39px] max-sm:p-4 place-items-center w-full">
      {products.map((product, index) => (
        <motion.div
          key={product.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="w-full flex justify-center"
        >
          <ProductCard
            id={product.id}
            image={product.image}
            title={product.title}
            onProductClick={onProductClick}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default ProductGrid;
